import { createFileRoute } from "@tanstack/react-router";
import { motion, MotionConfig } from "motion/react";
import { ShieldOff } from "lucide-react";
import { GuildPermissions } from "@/components/guilds/guild-permissions";
import { useGuildPermissions } from "@/hooks/use-guild-permissions";

export const Route = createFileRoute(
  "/dashboard/guilds/$applicationGuildId/permissions"
)({
  component: PermissionsPage,
});

function PermissionsPage() {
  const { canEdit } = useGuildPermissions();

  if (!canEdit("guildSettings")) {
    return (
      <MotionConfig reducedMotion="user">
        <div className="flex min-h-[40vh] items-center justify-center">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            className="flex max-w-sm flex-col items-center text-center"
          >
            <div className="mb-4 flex size-16 items-center justify-center rounded-2xl bg-gradient-to-br from-rose-500/10 to-red-500/10 ring-1 ring-rose-500/10">
              <ShieldOff className="size-8 text-rose-500/80" />
            </div>
            <h2 className="mb-1 text-balance text-lg font-semibold">
              No permission
            </h2>
            <p className="text-muted-foreground text-pretty text-sm">
              You don't have access to manage guild permissions. Ask a guild
              owner or admin to grant you edit access to Settings.
            </p>
          </motion.div>
        </div>
      </MotionConfig>
    );
  }

  return <GuildPermissions />;
}
